const billingOptions = { label: 'Billed Monthly', value: 1 };

export { billingOptions };
